// extracted by mini-css-extract-plugin
module.exports = {"jumbotronSmall":"Hero_jumbotronSmall__IN8kP"};